
export default {
  props: ["hideButton"],
  data() {
    return {
      partnerId: "",
      open: false,
    };
  },
  mounted() {
    let self = this;
    this.$store.getters.store.shippings.forEach((s) => {
      if (s.key_boxnow) {
        this.partnerId = s.key_boxnow;
        $nuxt.$on(s.key_emit, (_) => {
          self.open = true;

          self.init();
        });
      }
    });
  },
  methods: {
    async init() {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      let childWindow = document.getElementById("boxnow");
      if (!childWindow) return;
      childWindow = childWindow.contentWindow;
      let parent_shipping = this.$store.getters.store.shippings.find(
        (s) => s.key_boxnow
      );
      let self = this;
      window.addEventListener("message", (message) => {
        if (message.source !== childWindow) {
          return; // Skip message in this event listener
        }
        if (message.data) {
          let p = message.data;
          p = {
            id: p.boxnowLockerId,
            name: p.boxnowLockerName,
            addressLine1: p.boxnowLockerAddressLine1,
            addressLine2: p.boxnowLockerAddressLine2,
            postalCode: p.boxnowLockerPostalCode,
            lat: p.boxnowLockerLat,
            lng: p.boxnowLockerLng,
          };

          $nuxt.$emit("setShipping", {
            ...parent_shipping,
            lat: p.lat,
            lng: p.lng,
            name:p.name,
            id:p.id,
            address: {
              country: "GR",
              address: p.addressLine1,
              town: p.addressLine2,
              postal_code: p.postalCode,
            },
            options: [
              ...parent_shipping.options,
              { key: "info", value: `<span class="text-xs">Παραλαβή από</span><br> <span class="font-bold">${p.name}</span> - ${p.addressLine1}, ${p.addressLine2} ${p.postalCode}` },
              { key: "locker_id", value: p.id },
            ],
            fullAddress: `${p.addressLine1}, ${p.addressLine2} ${p.postalCode}`,
            locker: p,
            skip_emit: true,
          });
          self.open = false;
        }
      });
    },
  },
};
